import { UseFormReturn } from "@/lib/form/form"
import { WidgetRegistry } from "@/lib/form/hooks"
import { FormSchema } from "@/lib/form/schema"
import { createContext, ReactNode, useContext } from "react"

interface FormContextValue {
  form: UseFormReturn
  registry: WidgetRegistry
  formSchema: FormSchema
  readOnly?: boolean
  sheetHasActiveBreakdown?: boolean
  getFieldPath: (prefix: string, field: string) => string
}

const FormContext = createContext<FormContextValue>({} as FormContextValue)

interface FormContextProviderProps {
  children?: ReactNode
  form: UseFormReturn
  formSchema: any
  registry: WidgetRegistry
  readOnly?: boolean
  additional?: Record<string, any>
}

export function FormContextProvider({
  form,
  registry,
  formSchema,
  readOnly,
  additional,
  children,
}: FormContextProviderProps) {
  function getFieldPath(prefix: string, field: string): string {
    return `${prefix}.${field}`
  }

  const value: FormContextValue = {
    form,
    registry,
    formSchema,
    readOnly,
    getFieldPath,
    ...additional,
  }

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>
}

export function useFormContext() {
  return useContext<FormContextValue>(FormContext)
}
